import { UISref } from "@uirouter/react";
import React, { FunctionComponent, useEffect, useState } from "react";
import styled from "styled-components";
import { PrimaryButton } from "../../components/button";
import { Icon } from "../../components/icons";
import { Flex } from "../../components/layout";
import { Spinner } from "../../components/loader/icon";
import { AuthService } from "../../store/auth/service";
import { colours } from "../../styles/colours";

type state = "loading" | "success" | "error";

const Container = styled(Flex).attrs({ center: true })`
  flex-direction: column;
  width: 16em;
  min-height: 10em;
  justify-content: space-between;
`;

const StyledIcon = styled(Icon)`
  height: 6em;
  width: 6em;
  margin: 3em;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 2em;
  text-align: center;
`;

export const EmailVerificationPage: FunctionComponent<{ token: string, shouldChangePassword: boolean }> = ({
  token,
  shouldChangePassword
}) => {
  const [componentState, setComponentState] = useState<state>("loading");

  useEffect(() => {
    AuthService.verifyEmail(token)
      .then(() => setComponentState("success"))
      .catch(() => setComponentState("error"));
  }, []);

  if (componentState === "loading") {
    return <Spinner />;
  }

  if (componentState === "success") {
    return (
      <Container>
        <Title className="h1">Your email has been verified!</Title>
        <StyledIcon type="veryGoodCheck" />
        {shouldChangePassword ? 
        <UISref to="^.reset" params={{ token, newPass: true }}>
          <PrimaryButton>Set your password</PrimaryButton>
        </UISref>
        :
        <UISref to="^.login">
          <PrimaryButton>Go to Login page</PrimaryButton>
        </UISref>
        }
      </Container>
    );
  }

  return (
    <Container>
      <Title className="h1">Your email could not be verified!</Title>
      <StyledIcon type="close" colour1={colours.red} />
      <p>Please contact customer support</p>
    </Container>
  );
};
